import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import background3 from '../assets/background3.png';

import UploadQRCode2 from './UploadQRCode2';

import './CSS/App.css';



const FeatureCard = ({
  to,
  icon,
  title,
  subtitle,
  external,
  cardClass = ''
}) => {


  const isExternal = external || to.startsWith('http');



  const content = (

    <div className={`feature-card ${cardClass}`}>

      <div className="card-icon">
        {icon}
      </div>


      <div className="card-text">

        <h3>
          {title}
        </h3>


        <p>
          {subtitle}
        </p>

      </div>


    </div>

  );



  if (isExternal) {


    return (

      <a

        href={to}

        target="_blank"

        rel="noopener noreferrer"

        className="feature-card-link"

      >

        {content}

      </a>

    );

  }



  return (

    <Link

      to={to}

      className="feature-card-link"

    >

      {content}

    </Link>

  );

};








class App extends Component {


  constructor(props) {

    super(props);


    this.state = {

      query:'',
      results:[]

    };

  }







  handleSearch = async () => {


    if (!this.state.query.trim()) return;



    try {


      const res = await axios.get(

        `/api/search?q=${encodeURIComponent(
          this.state.query
        )}`

      );



      this.setState({

        results:res.data

      });



    } catch(err) {


      console.log(err);


    }


  };









  render() {


    const pageStyle = {


      backgroundImage:

      `linear-gradient(
        rgba(255,255,255,0.20),
        rgba(255,255,255,0.20)
      ),
      url(${background3})`,



      backgroundSize:'cover',



      backgroundPosition:'center',



      backgroundRepeat:'no-repeat',



      minHeight:'100vh'


    };






    return (


      <div

        className="app-container"

        style={pageStyle}

      >







        <header className="app-header">





          <img

            className="logo"

            src={logo}

            alt="Thai-Aikikai Logo"

          />







          <h1>

            Thailand&apos;s Aikido Association

          </h1>







          <p className="tagline">

            Registration • Class Attendance • Member System

          </p>









          {/* SEARCH BAR */}



          <div className="homepage-search">



            <input

              type="text"

              placeholder="Search members, instructors, dojos..."

              value={this.state.query}



              onChange={(e)=>

                this.setState({

                  query:e.target.value

                })

              }



              onKeyDown={(e)=>

                e.key === 'Enter' &&

                this.handleSearch()

              }


            />





            <button

              onClick={this.handleSearch}

            >

              Search

            </button>



          </div>









          {/* QR UPLOAD */}



          <UploadQRCode2 />









          {/* SEARCH RESULTS */}



          <div className="homepage-results">



            {

              this.state.results.map(item => (


                <Link

                  to={item.url}

                  key={item.id}

                  className="homepage-result-link"

                >



                  <div className="homepage-result-card">


                    <h2>

                      {item.title}

                    </h2>



                    <p className="homepage-result-url">

                      {item.url}

                    </p>




                    <p>

                      {item.description}

                    </p>



                  </div>



                </Link>


              ))

            }



          </div>







        </header>









        <section className="dashboard-grid">





          <FeatureCard
            to="/register"
            icon="🪪"
            title="Members Register"
            subtitle="Create your Thai-Aikikai member account"
          />




          <FeatureCard
            to="/login"
            icon="🔐"
            title="Members Login"
            subtitle="Access your member profile"
          />




          <FeatureCard
            to="/dojos"
            icon="🥋"
            title="Affiliated Dojos"
            subtitle="View official Thai-Aikikai dojos"
          />




          <FeatureCard
            to="/instructors"
            icon="👨‍🏫"
            title="Our Instructors"
            subtitle="Meet certified Aikido instructors"
          />




          <FeatureCard
            to="/shop"
            icon="🛒"
            title="Thai-Aikikai Shop"
            subtitle="Uniforms, equipment, and official items"
          />




          <FeatureCard
            to="/goshinjitsu"
            icon="🛡️"
            title="Aiki Goshin Jitsu"
            subtitle="Self-defense course"
          />




          <FeatureCard
            to="/weaponsclass"
            icon="⚔️"
            title="Weapons Class"
            subtitle="Aiki Ken and Jo training"
          />




          <FeatureCard
            to="/testrecords"
            icon="📜"
            title="All Test Records"
            subtitle="View grading and examination records"
          />




          <FeatureCard
            to="/forms"
            icon="📄"
            title="Forms"
            subtitle="Download and submit official forms"
          />




          <FeatureCard
            to="/paymentmethods"
            icon="💳"
            title="Buy Aiki Tokens"
            subtitle="Top-up tokens for services"
          />




          <FeatureCard
            to="/shimbun"
            icon="📰"
            title="Thai Aikikai Shimbun"
            subtitle="Thai Aikikai Newsletters"
          />




          <FeatureCard
            to="https://www.facebook.com/groups/1530621582006737"
            icon="👥"
            title="Thai Aikikai Group"
            subtitle="Join official community group"
          />




        </section>









        <footer className="app-footer">



          <p>
            Powered by
          </p>





          <img

            className="logo2"

            src={logo2}

            alt="New Wave Consulting Group"

          />





          <p>

            New Wave Consulting Group

          </p>





        </footer>







      </div>


    );

  }


}




export default App;
